/** Minimal client-side JWT helpers (payload decode only, no verification). */

export interface JwtPayload {
  exp?: number
  iat?: number
  sub?: string
  typ?: string
}

export function decodeJwt(token: string): JwtPayload | null {
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = atob(b64)
    return JSON.parse(json) as JwtPayload
  } catch {
    return null
  }
}

/** True when the token is missing, undecodable, or expired (with skew). */
export function isExpired(token: string | null, skewSeconds = 15): boolean {
  if (!token) return true
  const payload = decodeJwt(token)
  if (!payload?.exp) return true
  return payload.exp <= Math.floor(Date.now() / 1000) + skewSeconds
}
